import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';

export interface Point {
    lat: number;
    lng: number;
    timestamp?: string;
}

export interface QuestRoute {
    questId: string;
    walking: Point[];
    running: Point[];
    fastRunning: Point[];
}

class QuestsStore {
    routes: QuestRoute[] = [];
    loading = false;

    constructor() {
        makeAutoObservable(this);
    }

    async loadQuestRoute(questId: string) {
        this.loading = true;
        try {
            // Получаем данные CompletedTask с бэка
            const res = await axios.get(`/api/quests/${questId}/route`);
            const data = res.data; // объект CompletedTask

            runInAction(() => {
                this.routes = [
                    ...this.routes.filter(r => r.questId !== questId),
                    {
                        questId,
                        walking: JSON.parse(data.WalkingPoints || '[]'),
                        running: JSON.parse(data.RunningPoints || '[]'),
                        fastRunning: JSON.parse(data.FastRunningPoints || '[]'),
                    },
                ];
                this.loading = false;
            });
        } catch (e) {
            console.error('Ошибка загрузки маршрута:', e);
            runInAction(() => (this.loading = false));
        }
    }

    getRouteByQuest(questId: string) {
        return this.routes.find(r => r.questId === questId);
    }
}

export const questsStore = new QuestsStore();
